<div class="container-fluid">
    <!-- Page Header with Utility Buttons -->
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
        <h1 class="page-header mb-2 mb-lg-0">Enrollment List</h1>

        <!-- Utility Buttons -->
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
            <div class="d-flex flex-wrap gap-1">
                <button *ngIf="_permissionsService.canAccess('enrollments_create')"
                    color="primary"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="openEnrollmentComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'create', null)">
                    Add Enrollment
                </button>
                <button *ngIf="_permissionsService.canAccess('reports_export')"
                        (click)="exportEnrollmentList()"
                        [disabled]="isLoading || isExporting"
                        color="primary"
                        mat-flat-button
                        class="me-1 mb-1 warning">
                    <mat-icon *ngIf="isExporting" class="mat-icon-animate-spin">autorenew</mat-icon>
                    <ng-container *ngIf="!isExporting">
                        <mat-icon>file_download</mat-icon>
                        <span>Export</span>
                    </ng-container>
                </button>
                <button *ngIf="_permissionsService.canAccess('reports_export')"
                        style="background-color: transparent !important; border: none;"
                        (click)="printEnrollmentList()"
                        [disabled]="isLoading"
                        type="button"
                        mat-icon-button
                        class="me-1 mb-1"
                        matTooltip="Print enrollment list"
                        matTooltipPosition="below"
                        aria-label="Print enrollment list">
                    <mat-icon style="color: #1C3F8B;">print</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Filter
            </mat-panel-title>
            <mat-panel-description>
                <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
            <div class="row">

                <div class="col-12 col-sm-6 col-lg">
                    <!-- <mat-form-field class="full-width-field">
                        <mat-label>Instructor</mat-label>
                        <input
                            name="instructor"
                            (input)="onAutocompleteInstructor($event)"
                            matInput
                            ngModel
                            [matAutocomplete]="autoCompleteInstructor"
                            >
                        <button type="button" matSuffix mat-icon-button
                            aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field> -->
                    <!-- <mat-autocomplete #autoCompleteInstructor="matAutocomplete"
                        (optionSelected)="onSubmit(f)">
                        <mat-option
                            *ngFor="let option of autocompleteInstructorOptions"
                            [value]="option.label + ' ' + '(' + option.value + ')'">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete> -->
                    <mat-form-field class="full-width-field">
                        <mat-label>Instructor</mat-label>
                        <mat-select
                        matInput
                        ngModel
                        name="instructor"
                        (selectionChange)="onSubmit(f)">
                            <mat-option>None</mat-option>
                            <mat-option
                                *ngFor="let element of this._fieldsService.instructorData()"
                                [value]="element.uid">
                                {{ element.value }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Student Account</mat-label>
                        <input
                            #studentInput
                            name="title"
                            (input)="onAutocompleteStudent($event)"
                            matInput
                            ngModel
                            [matAutocomplete]="autoCompleteStudent"
                            >
                        <button (click)="redirectUserProfile(studentInput)" type="button" matSuffix mat-icon-button
                            aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompleteStudent="matAutocomplete"
                        (optionSelected)="onSubmit(f)">
                        <mat-option
                            *ngFor="let option of autoCompleteStudentOptions"
                            [value]="option.label">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Sale Date Range</mat-label>
                        <input #saleDateRangeInput matInput
                            [value]="saleDateRangeDisplayValue"
                            placeholder="Select date range"
                            readonly
                            name="field_sale_date_value">
                        <button matSuffix mat-icon-button type="button" (click)="openSaleDateRangePicker()">
                            <mat-icon>calendar_today</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-12 col-sm-6 col-lg">
                    <!-- <mat-form-field class="full-width-field">
                        <mat-label>Category</mat-label>
                        <input
                            name="field_category_target_id"
                            (input)="onViewsAutocompleteFiltersCategory($event)"
                            matInput
                            ngModel
                            [matAutocomplete]="autoCompleteCategory"
                            >
                        <button type="button" matSuffix mat-icon-button
                            aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompleteCategory="matAutocomplete"
                        (optionSelected)="onSubmit(f)">
                        <mat-option
                            *ngFor="let option of autoCompleteCategoryOptions"
                            [value]="option.label">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete> -->

                    <!-- <mat-form-field class="full-width-field">
                        <mat-label>Instructor</mat-label>
                        <mat-select
                        matInput
                        ngModel
                        name="instructor"
                        (selectionChange)="onSubmit(f)">
                            <mat-option>None</mat-option>
                            <mat-option
                                *ngFor="let element of this._fieldsService.instructorData()"
                                [value]="element.uid">
                                {{ element.value }}</mat-option>
                        </mat-select>
                    </mat-form-field> -->
                    <mat-form-field class="full-width-field">
                        <mat-label>Category</mat-label>
                        <mat-select (selectionChange)="onSubmit(f)" ngModel matInput name="field_category_target_id">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let element of this._taxonomyService.enrollment_type"
                                [value]="element.name">
                                {{ element.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- <div class="col-2">
                    <mat-form-field class="full-width-field">
                        <mat-label>Category</mat-label>
                        <input
                            matInput
                            ngModel
                            name="field_category_target_id"
                            (blur)="onSubmit(f)"
                            (selectionChange)="onSubmit(f)">
                    </mat-form-field>
                </div> -->

                <!-- Packages Autocomplete -->
                <div class="col-12 col-sm-6 col-lg">
                    <mat-form-field class="full-width-field">
                        <mat-label>Package Name</mat-label>
                        <input
                            name="field_package_id_value"
                            (input)="onAutocompletePackage($event)"
                            matInput
                            ngModel
                            [matAutocomplete]="autoCompletePackages">
                        <button type="button" matSuffix mat-icon-button
                            aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompletePackages="matAutocomplete"
                        (optionSelected)="onSubmit(f)">
                        <mat-option
                            *ngFor="let option of autoCompletePackageOptions"
                            [value]="option.value">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>


                <!-- <div class="col-2">
                    <mat-form-field class="full-width-field">
                        <mat-label>Lessons Paid</mat-label>
                        <input
                            matInput
                            ngModel
                            name="field_lessons_paid_value"
                            (blur)="onSubmit(f)"
                            (selectionChange)="onSubmit(f)">
                    </mat-form-field>
                </div> -->

                <!-- <div class="col-2">
            <mat-form-field class="full-width-field">
            <mat-label>Sort by</mat-label>
            <mat-select
                matInput
                ngModel
                name="sort_by"
                (blur)="onSubmit(f)"
                (selectionChange)="onSubmit(f)">
                <mat-option value="field_total_price_value" selected="selected">Total Price</mat-option>
                <mat-option value="field_lesson_count_value_1">Lesson Count</mat-option>
                <mat-option value="field_lesson_price_value">Lesson Price</mat-option>
            </mat-select>
            </mat-form-field>
        </div> -->
                <!-- <div class="col-2">
            <mat-form-field class="full-width-field">
            <mat-label>Order by</mat-label>
            <mat-select
                matInput
                ngModel
                name="sort_order"
                (blur)="onSubmit(f)"
                (selectionChange)="onSubmit(f)">
                <mat-option value="ASC" selected="selected">Asc</mat-option>
                <mat-option value="DESC">Desc</mat-option>
            </mat-select>
            </mat-form-field>
        </div> -->
                <section class="section">

                    <div class="float-end bring-inline">
                        <button (click)="resetForm()" color="primary"
                            mat-flat-button
                            class="me-1" mat-button>Clear
                            <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
                        </button>
                    </div>

                </section>


            </div>


            <section class="section">
            </section>

        </form>

    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

    <!-- <mat-form-field appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
    </mat-form-field> -->

    <!-- <div class="example-container mat-elevation-z8">
    <div class="loading-shade"
    *ngIf="ShowProgressBar">
    <mat-spinner *ngIf="ShowProgressBar"></mat-spinner>
    <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
        No limit
    </div>
    </div>
    </div> -->

    <div class="table-responsive-sticky table-responsive">

        <table mat-table #displayTable [dataSource]="dataSource"
            matSort
            (matSortChange)="sortData($event)"
            class="mt-4">

            <!-- enrollmentID Column -->
            <ng-container matColumnDef="enrollmentID">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by enrollmentID">
                    ID
                </th>
                <td mat-cell *matCellDef="let element">
                    <span *ngIf="!element.isAdjustmentRow">{{element.id}}</span>
                    <span *ngIf="element.isAdjustmentRow" class="adjustment-label">Adjustment</span>
                </td>
            </ng-container>

            <!-- field_contacts Column -->
            <ng-container matColumnDef="field_contacts">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_contacts">
                    Student
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        <ng-container *ngIf="element.field_is_gift_certificate === 1 || element.field_is_gift_certificate === true; else regularStudent">
                            Gift Certificate
                        </ng-container>
                        <ng-template #regularStudent>
                            <a
                            class="cursor-pointer"
                            (click)="openDialog(StudentDashboardWrapperComponent, 'largerScreenDashboard', {
                                student_id: element.student_contact_id
                            })"
                            >
                            {{ element.field_contacts }}
                            </a>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        {{ element.field_contacts }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_sale_date Column -->
            <ng-container matColumnDef="field_sale_date">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_sale_date">
                    Sale Date
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ formatEnrollmentDate(element.field_sale_date) }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        {{ formatEnrollmentDate(element.field_dropped_date) }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_instructor Column -->
            <ng-container matColumnDef="field_instructor">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_instructor">
                    Instructor
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ element.field_first_name | htmlDecode }}
                        {{ element.field_last_name | htmlDecode }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        {{ element.field_first_name | htmlDecode }}
                        {{ element.field_last_name | htmlDecode }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_executive Column -->
            <ng-container matColumnDef="field_executive">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_executive">
                    Executive
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.field_executive_first_name | htmlDecode }}
                    {{ element.field_executive_last_name | htmlDecode }}
                </td>
            </ng-container>

            <!-- AllEnrollmentInstructors Column -->
            <ng-container matColumnDef="AllEnrollmentInstructors">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by AllEnrollmentInstructors">
                    Instructors (%)
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ element.AllEnrollmentInstructors }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        {{ element.AllEnrollmentInstructors }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_category Column -->
            <ng-container matColumnDef="field_category">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_category">
                    Category
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ element.field_category }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        <span class="adjustment-label">{{ element.field_category }} (Adjustment)</span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_package_name Column -->
            <ng-container matColumnDef="field_package_name">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_package_name">
                    Package Name
                </th>
                <td mat-cell *matCellDef="let element"> {{
                    element.field_enrollment_package_name }} </td>
            </ng-container>

            <!-- field_enrollment_lesson_count Column -->
            <ng-container matColumnDef="field_enrollment_lesson_count">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_enrollment_lesson_count">
                    # of Lessons
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ element.field_enrollment_lesson_count }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        <div class="adjustment-container">
                            <div class="adjustment-value">{{ element.adjustmentLessonCount }}</div>
                            <div class="adjustment-total">= {{ element.finalLessonCount }}</div>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_enrollment_total_price Column -->
            <ng-container matColumnDef="field_enrollment_total_price">
                <th mat-header-cell *matHeaderCellDef class="text-end"
                    sortActionDescription="Sort by field_enrollment_total_price">
                    Total Price
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        <ng-container *ngIf="element.withTax?.totalTax; else priceNoTax">
                            {{ element.withTax.total | studioCurrency }}
                            <small class="d-block text-muted text-nowrap">{{ element.field_enrollment_total_price | studioCurrency }} + {{ element.withTax.totalTax | studioCurrency }} {{ taxMode?.label }}</small>
                        </ng-container>
                        <ng-template #priceNoTax>{{ element.field_enrollment_total_price | studioCurrency }}</ng-template>
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        <div class="adjustment-container">
                            <div class="adjustment-value">{{ element.adjustmentTotalPrice | studioCurrency }}</div>
                            <div class="adjustment-total">= {{ element.finalTotalPrice | studioCurrency }}</div>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_total_paid Column -->
            <ng-container matColumnDef="field_total_paid">
                <th mat-header-cell *matHeaderCellDef class="text-end" sortActionDescription="Sort by field_total_paid">
                  Total Paid
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        <ng-container *ngIf="element.withTax?.paidTax; else paidNoTax">
                            {{ element.withTax.paid | studioCurrency }}
                            <small class="d-block text-muted text-nowrap">{{ element.field_total_payments_made | studioCurrency }} + {{ element.withTax.paidTax | studioCurrency }} {{ taxMode?.label }}</small>
                        </ng-container>
                        <ng-template #paidNoTax>{{ element.field_total_payments_made | studioCurrency }}</ng-template>
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        <div class="adjustment-container">
                            <div class="adjustment-value">{{ element.adjustmentTotalPaid | studioCurrency }}</div>
                            <div class="adjustment-total">= {{ element.finalTotalPaid | studioCurrency }}</div>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_balance_due Column -->
            <ng-container matColumnDef="field_balance_due">
                <th mat-header-cell *matHeaderCellDef class="text-end"
                    sortActionDescription="Sort by field_balance_due">
                    Total Due
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" class="text-end">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        <ng-container *ngIf="element.withTax?.dueTax; else dueNoTax">
                            {{ element.withTax.due | studioCurrency }}
                            <small class="d-block text-muted text-nowrap">{{ element.field_balance_due | studioCurrency }} + {{ element.withTax.dueTax | studioCurrency }} {{ taxMode?.label }}</small>
                        </ng-container>
                        <ng-template #dueNoTax>{{ element.field_balance_due | studioCurrency }}</ng-template>
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        <div class="adjustment-container">
                            <div class="adjustment-value">{{ element.adjustmentBalanceDue | studioCurrency }}</div>
                            <div class="adjustment-total">= {{ element.finalBalanceDue | studioCurrency }}</div>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_additional_notes Column -->
            <ng-container matColumnDef="field_additional_notes">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_additional_notes">
                    Last Paid
                </th>
                <td mat-cell *matCellDef="let element">{{ formatEnrollmentDate(element.field_last_paid_date) }}</td>
            </ng-container>

            <!-- field_lesson_available Column -->
            <ng-container matColumnDef="field_lesson_available">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_lesson_available">
                    Lessons Available
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'adjustment-value': element.isAdjustmentRow}" [style.color]="element.field_lesson_available < 0 ? 'red' : ''">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        {{ +element.field_lesson_available }}
                    </ng-container>
                    <ng-container *ngIf="element.isAdjustmentRow">
                        {{ +element.field_lesson_available }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_lesson_available Column -->
            <ng-container matColumnDef="isDropped">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by field_lesson_available">
                    Drop
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isAdjustmentRow">
                        <span class="text-nowrap">{{ element.field_dropped_date ? '✓' : ''  }} {{ formatEnrollmentDate(element.field_dropped_date) }}</span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- field_notes Column -->
            <ng-container matColumnDef="field_notes">
                <th mat-header-cell *matHeaderCellDef>Notes</th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon
                        *ngIf="element.field_notes"
                        [matTooltip]="element.field_notes | htmlDecode"
                        matTooltipPosition="above"
                    >notes</mat-icon>
                </td>
            </ng-container>

            <!-- nothing Column -->
            <!-- <ng-container matColumnDef="nothing">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by nothing">
                    Hide
                </th>
                <td mat-cell *matCellDef="let element">
                </td>
            </ng-container> -->

            <mat-menu #enrollmentMenu="matMenu">
                <ng-template matMenuContent let-enrollmentID="enrollmentID" let-student_account_id="student_account_id" let-balance_due="balance_due" let-studio_id="studio_id">
                    <button mat-menu-item
                        (click)="openEnrollmentComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'view', enrollmentID)"
                        >
                        View
                    </button>
                    <button *ngIf="_permissionsService.canAccess('enrollments_edit') && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openEnrollmentComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'editEnrollment', enrollmentID)"
                        >
                        Edit
                    </button>
                    <button *ngIf="_permissionsService.canAccess('enrollments_edit') && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openEnrollmentComponent(SignatureEnrollmentComponent, 'packages', 'enrollment', 'signEnrollment', enrollmentID)"
                        >
                        Sign
                    </button>
                    <button *ngIf="_permissionsService.canAccess('enrollments_cancel') && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openEnrollmentComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'delete', enrollmentID)"
                        >
                        Delete
                    </button>
                    <button *ngIf="_permissionsService.canAccess('enrollments_cancel') && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openEntityComponent(EnrollmentDropComponent, 'packages', 'enrollment', 'drop', enrollmentID)"
                        >
                        Drop
                    </button>
                    <button *ngIf="_permissionsService.canAccess('payments_collect') && ownsEnrollment(studio_id)" mat-menu-item
                        [disabled]="balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0"
                        [matTooltip]="balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0 ? 'Cannot add payment: no balance due' : ''"
                        [matTooltipDisabled]="!(balance_due === undefined || balance_due === null || balance_due === '' || +balance_due !== +balance_due || +balance_due === 0)"
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'create', null, { field_enrollment_name: [{ target_id: enrollmentID, payment_amount: 0 }], field_student_name: student_account_id })"
                        >
                        Add Payment
                    </button>
                    <button *ngIf="_permissionsService.canAccess('payments_refund') && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openEntityComponent(PaymentsEntityComponent, 'payments', 'payment', 'refund', null, {field_gross_tuition: '', field_enrollment_name: {target_id: enrollmentID }, field_student_name: student_account_id, field_payment_type: '71'})"
                        >
                        Refund
                    </button>
                    <button mat-menu-item
                        (click)="openEntityComponentXL(EnrollmentViewLessonComponent, 'packages', 'enrollment', '0', enrollmentID)"
                        >
                        View Lessons
                    </button>
                    <button mat-menu-item
                        (click)="openEntityComponent(ViewPaymentsFromEnrollmentComponent, 'packages', 'enrollment', null, enrollmentID)"
                        >
                        View Payments
                    </button>
                    <button mat-menu-item
                        (click)="openEntityComponent(ViewPaymentsDueFromEnrollmentComponent, 'packages', 'enrollment', null, enrollmentID)"
                        >
                        View Payments Due
                    </button>
                    <button *ngIf="_permissionsService.isSuperAdmin() && ownsEnrollment(studio_id)" mat-menu-item
                        (click)="openAdjustmentDialog(enrollmentID)"
                        >
                        Adjust Lessons
                    </button>
                </ng-template>
            </mat-menu>

            <!-- nothing_1 Column -->
            <ng-container matColumnDef="nothing_1">
                <th mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by nothing_1">
                    Actions
                </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="!element.isAdjustmentRow" mat-icon-button [matMenuTriggerFor]="enrollmentMenu" [matMenuTriggerData]="{ enrollmentID: element.id, student_account_id: element.field_contacts + ' (' + element.student_account_id + ')', balance_due: element.field_balance_due, studio_id: element.field_studio_reference }">
                    <mat-icon>more_vert</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Footer for pagination -->
            <ng-container matColumnDef="pagination-footer">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
                    <mat-paginator
                        [disabled]="ShowProgressBar"
                        (page)="pageChanged($event)"
                        [pageSizeOptions]="onPageSizeOptions()"
                        [length]="30"
                        [pageSize]="paginationTotalPages"
                        [pageIndex]="paginationIndex"
                        aria-label="Select page of view"></mat-paginator>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{
                    'dropped-enrollment': row.field_dropped_date && !row.isAdjustmentRow || row.isAdjustmentRow,
                    'adjustment-row': row.isAdjustmentRow
                }"></tr>
            <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
        </table>

    </div>
</div>
